// Franchises: one brand, with local branches run by separate owners.
// To add one, add its website (no https or www) on a new line, e.g.:
//   "metro-rod.co.uk",
export const FRANCHISE_SITES = [
];
